import * as monaco from 'monaco-editor'

export function configureMonaco(): void {
  monaco.editor.defineTheme('craft-dark', {
    base: 'vs-dark',
    inherit: true,
    rules: [
      { token: 'delimiter.twig',       foreground: '0fdb63' },
      { token: 'keyword.twig',         foreground: 'C586C0' },
      { token: 'variable.twig',        foreground: '86efac' },
      { token: 'string.twig',          foreground: 'CE9178' },
      { token: 'number.twig',          foreground: 'B5CEA8' },
      { token: 'operator.twig',        foreground: 'D4D4D4' },
      { token: 'comment.twig',         foreground: '6A9955', fontStyle: 'italic' },
      { token: 'comment.html',         foreground: '6A9955', fontStyle: 'italic' },
      { token: 'tag.html',             foreground: '0fdb63' },
      { token: 'metatag.html',         foreground: '0fdb63' },
      { token: 'attribute.name.html',  foreground: '86efac' },
      { token: 'attribute.value.html', foreground: 'CE9178' },
    ],
    colors: {
      'editor.background':              '#27353f',
      'editor.lineHighlightBackground': '#364958',
      'editorLineNumber.foreground':    '#5a7585',
      'editorCursor.foreground':        '#0fdb63',
      'editor.selectionBackground':     '#0fdb6340',
      'editorWidget.background':        '#1f2d39',
      'editorSuggestWidget.background': '#1f2d39',
      'editorSuggestWidget.border':     '#3a5467',
      'tab.activeBackground':           '#27353f',
      'tab.inactiveBackground':         '#21303d',
    },
  })

  monaco.languages.register({ id: 'twig', extensions: ['.twig', '.html.twig'], aliases: ['Twig', 'twig'] })

  // Monarch tokenizer — handles {{ }}, {% %}, {# #} mixed into HTML
  monaco.languages.setMonarchTokensProvider('twig', {
    defaultToken: '',

    keywords: [
      'if', 'else', 'elseif', 'endif', 'for', 'endfor', 'in',
      'block', 'endblock', 'extends', 'include', 'import', 'from',
      'set', 'macro', 'endmacro', 'with', 'endwith', 'apply', 'endapply',
      'not', 'and', 'or', 'is', 'null', 'true', 'false', 'none',
      'do', 'flush', 'verbatim', 'endverbatim',
    ],

    tokenizer: {
      root: [
        [/{#/, 'comment.twig', '@twigComment'],
        [/{%-?/, 'delimiter.twig', '@twigBlock'],
        [/{{-?/, 'delimiter.twig', '@twigVar'],
        [/<!--/, 'comment.html', '@htmlComment'],
        [/<!\w+/, 'metatag.html', '@htmlMeta'],
        [/<\/[\w-]+\s*>/, 'tag.html'],
        [/<[\w-]+/, 'tag.html', '@htmlTag'],
        [/[^<{]+/],
      ],

      twigComment: [
        [/#}/, 'comment.twig', '@pop'],
        [/./, 'comment.twig'],
      ],

      twigBlock: [
        [/-?%}/, 'delimiter.twig', '@pop'],
        [/\b(if|else|elseif|endif|for|endfor|in|block|endblock|extends|include|import|from|set|macro|endmacro|with|endwith|apply|endapply|not|and|or|is|null|true|false|none|do|flush|verbatim|endverbatim)\b/, 'keyword.twig'],
        [/"[^"]*"/, 'string.twig'],
        [/'[^']*'/, 'string.twig'],
        [/\d+(?:\.\d+)?/, 'number.twig'],
        [/[|.,:()\[\]{}~+\-*/!%=<>?@]/, 'operator.twig'],
        [/[a-zA-Z_$][\w$]*/, 'variable.twig'],
        [/\s+/],
      ],

      twigVar: [
        [/-?}}/, 'delimiter.twig', '@pop'],
        [/\b(not|and|or|is|null|true|false|none)\b/, 'keyword.twig'],
        [/"[^"]*"/, 'string.twig'],
        [/'[^']*'/, 'string.twig'],
        [/\d+(?:\.\d+)?/, 'number.twig'],
        [/[|.,:()\[\]{}~+\-*/!%=<>?@]/, 'operator.twig'],
        [/[a-zA-Z_$][\w$]*/, 'variable.twig'],
        [/\s+/],
      ],

      htmlComment: [
        [/-->/, 'comment.html', '@pop'],
        [/[^-]+/, 'comment.html'],
        [/./, 'comment.html'],
      ],

      htmlMeta: [
        [/>/, 'metatag.html', '@pop'],
        [/"[^"]*"/, 'attribute.value.html'],
        [/[^>"]+/],
      ],

      htmlTag: [
        [/>/, 'tag.html', '@pop'],
        [/\/\s*>/, 'tag.html', '@pop'],
        [/\s+/],
        [/[a-zA-Z_:][a-zA-Z0-9_:.-]*\s*=/, 'attribute.name.html', '@htmlAttrVal'],
        [/[a-zA-Z_:][a-zA-Z0-9_:.-]*/, 'attribute.name.html'],
        [/{%-?/, 'delimiter.twig', '@twigBlock'],
        [/{{-?/, 'delimiter.twig', '@twigVar'],
      ],

      htmlAttrVal: [
        [/"[^"]*"/, 'attribute.value.html', '@pop'],
        [/'[^']*'/, 'attribute.value.html', '@pop'],
        [/[^\s>"'=]+/, 'attribute.value.html', '@pop'],
        [/$/, '', '@pop'],
      ],
    },
  } as monaco.languages.IMonarchLanguage)

  monaco.languages.setLanguageConfiguration('twig', {
    comments:  { blockComment: ['{#', '#}'] },
    brackets:  [['{%', '%}'], ['{{', '}}'], ['{', '}'], ['[', ']'], ['(', ')']],
    autoClosingPairs: [
      { open: '{%',  close: ' %}' },
      { open: '{{',  close: ' }}' },
      { open: '{#',  close: ' #}' },
      { open: '"',   close: '"',  notIn: ['string'] },
      { open: "'",   close: "'",  notIn: ['string'] },
      { open: '(',   close: ')' },
      { open: '[',   close: ']' },
    ],
    surroundingPairs: [
      { open: '{',  close: '}' },
      { open: '[',  close: ']' },
      { open: '(',  close: ')' },
      { open: '"',  close: '"' },
      { open: "'",  close: "'" },
    ],
    folding: {
      markers: {
        start: new RegExp('{%-?\\s*(block|for|if|macro|with|embed)\\b'),
        end:   new RegExp('{%-?\\s*(endblock|endfor|endif|endmacro|endwith|endembed)\\b'),
      },
    },
  })
}

export const DEFAULT_OPTIONS: monaco.editor.IStandaloneEditorConstructionOptions = {
  theme:                      'craft-dark',
  automaticLayout:            true,
  minimap:                    { enabled: true },
  fontSize:                   14,
  tabSize:                    2,
  insertSpaces:               true,
  scrollBeyondLastLine:       false,
  wordWrap:                   'on',
  suggestOnTriggerCharacters: true,
  quickSuggestions:           true,
  renderWhitespace:           'boundary',
  smoothScrolling:            true,
  cursorBlinking:             'smooth',
  formatOnPaste:              true,
  bracketPairColorization:    { enabled: true },
  padding:                    { top: 8 },
  contextmenu:                true,
  links:                      true,
  selectionHighlight:         true,
  folding:                    true,
  showFoldingControls:        'mouseover',
  stickyScroll:               { enabled: true },
}
